import { SampleProps } from '../../sample/activity-sample.constants';
import { getSubActivityInstructionAsText } from '../../sub-activity/sub-activity.utils';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import { ComponentOverlayWrapper } from '../../shared/component-overlay/component-overlay.style';
import ComponentOverlaySample from '../../shared/component-overlay/component-overlay-sample';
import SubActivityView from '../../sub-activity/sub-activity-view';
import { ViewProps } from '../fill-in-blanks.constants';
import FillInBlanksViewAnswers from '../fill-in-blanks-view-answers';
import FillInBlanksSampleClassAnswers from './fill-in-blanks-sample-class-answers';

const FillInBlanksSample = (props: ViewProps & SampleProps) => {
  const { subActivityProperties } = props;

  const { isVisible, openModal, closeModal } = useSimpleModalState();

  return (
    <SubActivityView subActivityDetails={subActivityProperties}>
      {isVisible && (
        <FillInBlanksSampleClassAnswers {...props} onClose={closeModal} />
      )}
      <ComponentOverlayWrapper>
        <FillInBlanksViewAnswers {...props} />
        <ComponentOverlaySample
          ariaLabel={`View Fill in the Blanks activity for: ${getSubActivityInstructionAsText(
            subActivityProperties?.instructions
          )}`}
          onClick={openModal}
        />
      </ComponentOverlayWrapper>
    </SubActivityView>
  );
};

export default FillInBlanksSample;
